import * as actionTypes from './actionTypes';

export const fetchAllSpaces = () => ({
  type: actionTypes.FETCH_ALL,
});
export const fetchAllSpacesSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  ids,
});

export const fetchAllSpacesForAllFolderTrees = () => ({
  type: actionTypes.FETCH_ALL_FOR_ALL_FOLDER_TREES,
});
export const fetchAllSpacesForAllFolderTreesSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_FOR_ALL_FOLDER_TREES_SUCCESS,
  ids,
});

export const createSpace = (space) => ({
  type: actionTypes.CREATE,
  space,
});
export const createSpaceSuccess = (space) => ({
  type: actionTypes.CREATE_SUCCESS,
  space,
});

export const deleteSpace = (space) => ({
  type: actionTypes.DELETE,
  space,
});
export const deleteSpaceSuccess = (id) => ({
  type: actionTypes.DELETE_SUCCESS,
  id,
});

export const updateSpace = (space) => ({
  type: actionTypes.UPDATE,
  space,
});
export const updateSpaceBody = (space) => ({
  type: actionTypes.UPDATE_BODY,
  space,
});
export const updateSpaceSuccess = (id) => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});

export const setActiveSpaceId = (id) => ({
  type: actionTypes.SET_ACTIVE_SPACE_ID,
  id,
});
